export const onChangeAndValidationPrice = (inputedValue, callBack) => {
  let isValidInput = true;
  const regex = /^(100(\.0{0,2})?|\d{1,2}(\.\d{0,2})?)%?$/;
  isValidInput = isValidInput && regex.test(inputedValue);
  if (isValidInput || !inputedValue) {
    if (callBack) callBack();
  }
};
